import { useEffect } from "react";

/**
 * Opens a dialog automatically when the page URL carries `?popup=<key>`.
 * Shareable deep links, e.g. /products/ova-balance?popup=notify
 */
const claimed = new Set<string>();

export function useAutoOpenPopup(key: string, open: (v: boolean) => void) {
  useEffect(() => {
    if (typeof window === "undefined") return;
    const value = new URLSearchParams(window.location.search).get("popup");
    const k = key.toLowerCase();
    if (value && value.toLowerCase() === k && !claimed.has(k)) {
      claimed.add(k);
      open(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [key]);
}
